import React from "react"

const AccountIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" height="100" width="100" viewBox="0 0 100 100" style={{ width: size, height: size }} aria-hidden="true">
			<path fill="currentColor" id="border" d="M85.36,14.64A50,50,0,0,0,14.64,85.36,50,50,0,0,0,85.36,14.64ZM50,95A45,45,0,1,1,95,50,45,45,0,0,1,50,95Z" />
			<circle fill="#FFFFFF" cx="50" cy="50" r="45" />
			<path fill="currentColor" id="grando" d="M35.43,66.66a17,17,0,0,1,0-34h0a17.08,17.08,0,0,1,17,17,16.68,16.68,0,0,1-4.89,11.94,16.91,16.91,0,0,1-12,5.1h-.06Zm0-30.48h0a13.48,13.48,0,1,0,0,27h0A13.44,13.44,0,0,0,45,59.08a13.2,13.2,0,0,0,3.88-9.43A13.57,13.57,0,0,0,35.45,36.18Z" />
			<path fill="currentColor" id="degre" d="M61.05,44.75a6,6,0,1,1,6-6A6,6,0,0,1,61.05,44.75Zm0-8.83a2.84,2.84,0,1,0,2.84,2.83A2.83,2.83,0,0,0,61.05,35.92Z" />
			<path fill="currentColor" id="petito" d="M71.38,67.28a10.25,10.25,0,0,1,0-20.5h0A10.3,10.3,0,0,1,81.62,57a10,10,0,0,1-3,7.24,10.2,10.2,0,0,1-7.23,3h0Zm0-17.16h0a6.92,6.92,0,0,0,0,13.83h0a6.84,6.84,0,0,0,4.84-2.05,6.75,6.75,0,0,0,2-4.87A7,7,0,0,0,71.39,50.12Z" />
		</svg>
	)
}

export default AccountIcon
